export const ENV_PRODUCTION = 'production';
export const ENV_STAGING = 'staging';
export const ENV_API_PROD = 'Prod';
export const ENV_API_PREPROD = 'PreProd';

export const ACTION_GET_ACCOMMODATION_PLACES = 'get_accommodation_places';
export const ACTION_GET_GLOBAL_VENUES = 'get_global_venues';
export const ACTION_GET_GLOBAL_EAT_DRINK_POSTS = 'get_global_eat_drink';
export const ACTION_GET_GLOBAL_OFFERS = 'get_global_offers';
export const ACTION_GET_GLOBAL_STORIES = 'get_global_stories';
export const ACTION_GET_HOTEL_OFFERS = 'get_hotel_offers';
export const ACTION_GET_HOTEL_THINGS_TO_DO = 'get_hotel_things_to_do';
export const ACTION_GET_BOOKING_API_TOKEN = '';

export const COOKIE_KEY_API_TOKEN = 'ode_ba_token';

export const COOKIE_KEY_HEADER_NOTIFICATIONS_EXPIRY = window.Ode['sharedConstants']['COOKIE_KEY_HEADER_NOTIFICATIONS_EXPIRY'];

export const COOKIE_KEY_ACCOMMODATION_SEARCH_LOCATION = window.Ode['sharedConstants']['COOKIE_KEY_ACCOMMODATION_SEARCH_LOCATION'];
export const COOKIE_KEY_ACCOMMODATION_SEARCH_START_DATE = window.Ode['sharedConstants']['COOKIE_KEY_ACCOMMODATION_SEARCH_START_DATE'];
export const COOKIE_KEY_ACCOMMODATION_SEARCH_END_DATE = window.Ode['sharedConstants']['COOKIE_KEY_ACCOMMODATION_SEARCH_END_DATE'];
export const COOKIE_KEY_ACCOMMODATION_SEARCH_RECENT = window.Ode['sharedConstants']['COOKIE_KEY_ACCOMMODATION_SEARCH_RECENT'];

export const COOKIE_KEY_VENUES_SEARCH_LOCATION = window.Ode['sharedConstants']['COOKIE_KEY_VENUES_SEARCH_LOCATION'];
export const COOKIE_KEY_VENUES_SEARCH_OCCASION = window.Ode['sharedConstants']['COOKIE_KEY_VENUES_SEARCH_OCCASION'];
export const COOKIE_KEY_VENUES_SEARCH_GUESTS = window.Ode['sharedConstants']['COOKIE_KEY_VENUES_SEARCH_GUESTS'];

export const EVENT_VIEW_TYPE_CHANGED = 'search_view_type_changed.ode';
export const EVENT_BALANCE_ELEMENTS = 'balance_elements.ode';
export const EVENT_BOOKING_SEARCH_PLACE_CHANGED = 'event_booking_search_place_changed';
export const EVENT_BOOKING_FORM_LOADED = 'booking_form_loaded';

export const EVENT_EAT_DRINK_CATEGORY_FILTER_CHANGED = 'eat_drink_category_changed.ode';
export const EVENT_EAT_DRINK_LOCATION_FILTER_CHANGED = 'eat_drink_location_changed.ode';

export const EVENT_OFFERS_LOCATION_FILTER_CHANGED = 'offers_location_changed.ode';
export const EVENT_OFFERS_TYPE_FILTER_CHANGED = 'offers_type_changed.ode';

export const EVENT_SUBMIT_CLICKED_SEARCH = 'search_submit_clicked.ode';

export const EVENT_STORIES_HOTELS_FILTER_CHANGED = 'stories_hotels_filter_changed.ode';
export const EVENT_CATEGORIES_HOTELS_FILTER_CHANGED = 'stories_categories_filter_changed.ode';

export const EVENT_NEIGHBORHOOD_TYPES_FILTER_CHANGED = 'neighborhood_types_filter_changed.evt_stays';

export const DATE_FORMAT_IN_VIEW = 'DD MMM, YYYY';
export const DATE_FORMAT_AUS = 'DD/MM/YYYY';
export const DATE_FORMAT_ISO = 'MM/DD/YYYY';
export const DATE_FORMAT_SITEMINDER = 'YYYY-MM-DD';



// WEBPACK FOOTER //
// ./scripts/util/constants.js